module.exports = "/365FarmNet/dist/machinePopup.3c36442b2e422064d0ab15d6c813174c.html";